import React, { useEffect, useState, useContext } from "react";
import FooterNew from "../components/Footer-New.js";
import NavbarInner from "../components/Navbar-Inner.js";



// import components
import ProTrade from "../components/ProTrade/ProTrade";

import NavbarInnerSide from "../components/NavbarInnerSide.js";
import Sidebar from "../components/Sidebar.js";


export default function TradePage(props) {


  const [isSidebarOpen, setIsSidebarOpen] = useState(false);


  return (
    <div>
   
     {/* <NavbarInner /> */}
      <NavbarInnerSide toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />

      <div className="flex w-full relative">
        <Sidebar isOpen={isSidebarOpen} closeSidebar={() => setIsSidebarOpen(false)} />
        <div className="flex-1 w-full overflow-hidden">
          <ProTrade />
        </div>
      </div>
      {/* <FooterNew/> */}
    </div>
  );
}
